module.exports = __webpack_public_path__ + "static/media/cake.a29c0b43.png";